import { Table, TableCell, Typography } from '@mui/material'
import React from 'react'
import { styled } from '@mui/material'

interface DocumentTableProps {
  children: React.ReactNode
}

export const WideDocTableCell = styled(TableCell)({
  width: '50%',
})

export const TableCellText = styled(
  ({ children, ...props }: { children: React.ReactNode }): JSX.Element => (
    <Typography component={'span'} sx={{ fontSize: '13px' }} {...props}>
      {children}
    </Typography>
  ),
)()

export const DocumentTable: React.FC<DocumentTableProps> = ({ children }) => {
  return (
    <Table
      sx={{
        width: '100%',
        td: {
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          padding: 1,
          fontWeight: 500,
        },
        'tr:last-child td': {
          borderBottom: 'none',
        },
        'tr:hover': {
          cursor: 'pointer',
          span: {
            textDecoration: 'underline',
          },
        },
        'tr:nth-child(even)': {
          backgroundColor: '#F5F5F5',
        },
      }}
    >
      <tbody>{children}</tbody>
    </Table>
  )
}
